import { render } from "./CreateCategoryModal.vue?vue&type=template&id=dbd03582&ts=true"
import script from "./CreateCategoryModal.vue?vue&type=script&lang=ts"
export * from "./CreateCategoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__